import { Button, Form, Input } from '@bancobarigui/barihaus';

import { RecoverPasswordFormData } from '../useRecoverPassword';

type Props = {
  onSubmit: (data: RecoverPasswordFormData) => void;
};

export function RecoverPasswordForm({ onSubmit }: Props) {
  return (
    <Form name="basic" onFinish={onSubmit} className="flex flex-col w-full gap-4">
      <Form.Item
        name="email"
        rules={[
          { required: true, message: 'Por favor, insira seu email!' },
          { type: 'email', message: 'Por favor, insira um email válido!' },
        ]}
      >
        <Input placeholder="email@exemplo.com" />
      </Form.Item>

      <Form.Item>
        <Button buttonColor="primary" block htmlType="submit">
          Enviar
        </Button>
      </Form.Item>
    </Form>
  );
}
